const module = { name: 'movie/shared/desktop/verifiedAudienceReview', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_dropdown as dropdown } from 'base-libraries';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { Fandango as Fandango_context } from 'require-core';

const { context: { featureFlags: { usePopovers } } } = Fandango_context;


const Selectors = {
    VERIFIED_ICON: '.js-audience-reviews__verified-link',
    VERIFIED_DROPDOWN: '#verified-dropdown-wrap',
    REVIEW_CONFIRM_INFO: '.js-confirm-modal__info',
    REVIEW_CONFIRM_MODAL: '#review-confirm-modal',
}


const Styles = {
    VERIFIED_DROPDOWN_WRAP: 'verified-dropdown__wrap',
}


const Messages = {
    GENERIC: 'Thanks! Your rating has been submitted.',
    VERIFIED: 'Thanks! Your rating has been submitted.  Your ticket purchase has been confirmed and a "Verified" tag may appear next to your review.'
}
function onClick(e) {
    const { currentTarget: target } = e;
    const verifiedDropdown = document.querySelector(`${Selectors.VERIFIED_DROPDOWN}-${target.dataset.index}`).innerHTML;
    const parentNode = document.querySelector('#' + target.id).parentNode;
    dropdown.open(verifiedDropdown, {
        relativeParent: parentNode,
        dropdownStyle: Styles.VERIFIED_DROPDOWN_WRAP,
    });
}
function init() {
    const type = sessionStorage.getItem('newReviewConf');
    if (type) {
        const info = document.querySelector(Selectors.REVIEW_CONFIRM_INFO);
        info.append(Messages[type]);
        modal.init(Selectors.REVIEW_CONFIRM_INFO, Selectors.REVIEW_CONFIRM_MODAL);
        setTimeout(() => info.click(), 1000);
        sessionStorage.removeItem('newReviewConf');
    }
    if (!usePopovers) {
        $(document.body).on('click', Selectors.VERIFIED_ICON, onClick);
    }
}
module.exports = {
    init
};
export default module.exports;